<script setup lang="ts">
import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { UnitDataPayload, UnitDataResponse } from "@/types/interface/unit";
import { useUnitStore } from "@/stores/master/unit";

const idUnit = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const unitStore = useUnitStore();
const detailUnit = ref<UnitDataResponse>();

const validationSchema = toTypedSchema(
  zod.object({
    name: zod.string().nonempty({ message: "Name is required" }),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: name } = useField<string>("name");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadUnit: UnitDataPayload = {
    name: name.value,
  };

  const responseApi = ref<any>();

  if (isEdit.value == true) {
    responseApi.value = await unitStore.dispatchUpdate(
      idUnit.value,
      payloadUnit
    );
  } else {
    responseApi.value = await unitStore.dispatchCreate(payloadUnit);
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value ? "Unit Successfully Updated" : "Unit Successfully Added"
      );
      router.push("/master/unit");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadDetailUnit = async () => {
  const { success, message } = await unitStore.dispatchDetail(idUnit.value);
  if (success) {
    detailUnit.value = await unitStore?.unit?.data;
    name.value = detailUnit.value?.name;
  }
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idUnit.value = router.currentRoute.value.params.id.toString();
    loadDetailUnit();
  }
});
</script>
<template>
  <div class="row justify-content-center">
    <div class="col-lg-12">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4"
          >
            <h3 class="mb-0">Form Create Unit</h3>
            <a
              class="btn btn-danger fw-semibold text-white px-3"
              type="button"
              href="/master/unit"
            >
              <i class="ri-arrow-drop-left-line text-gray-light"></i>
              Back To List Unit
            </a>
          </div>
          <BaseLoading text="Processing Data..." v-if="isLoading" />
          <form
            @submit="onSubmit"
            class="row g-3 needs-validation form"
            v-if="!isLoading"
          >
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="name" class="form-label label text-secondary"
                    >Unit Name <span class="text-danger">*</span></label
                  >
                  <div class="position-relative">
                    <input
                      name="name"
                      v-model="name"
                      placeholder="Unit Name"
                      type="text"
                      class="form-control text-dark"
                    />
                  </div>
                  <span class="text-danger">{{ errors.name }}</span>
                </div>
              </div>
              <div class="col-12 mt-5">
                <button
                  class="btn btn-primary fw-semibold text-white py-2 px-3"
                  type="submit"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
